<div class="form-group mb-2">
  <ui-input
    type="text"
    placeholder="Search..."
    [fullWidth]="true"
    [clearable]="true"
    [value]="searchControl.value ?? ''"
    (valueChange)="searchControl.setValue($event)"
  />
</div>

<!-- Provider filter badges -->
<div class="mb-2 flex flex-wrap gap-2">
  @for (badge of providerBadges; track badge) {
    <button
      type="button"
      class="badge badge-sm cursor-pointer select-none"
      [ngClass]="{ 'badge-primary text-primary-content': isProviderSelected(badge.value), 'badge-ghost': !isProviderSelected(badge.value) }"
      (click)="toggleProvider(badge.value)">
      {{ badge.label }}
    </button>
  }
</div>

@if ((searchControl.value ?? '').length >= 3 && products.length === 0) {
  <div class="text-sm text-base-content/60">No results found.</div>
}

@if (products.length > 0) {
  <div class="mt-2"
       [class.overflow-y-auto]="!!resultsMaxHeight"
       [style.max-height]="resultsMaxHeight || null">
  <ul class="rounded-box border border-base-200 bg-base-100 overflow-hidden">
    @for (item of products; track item) {
      <li
        class="px-2 py-2 cursor-pointer hover:bg-base-200/60 active:bg-base-200 catalog-result"
        (click)="selectItem(item)"
        (keydown.enter)="selectItem(item)"
        (keydown.space)="$event.preventDefault(); selectItem(item)"
        (keyup.enter)="$event.preventDefault()"
        (keyup.space)="$event.preventDefault()"
        (mouseenter)="onItemPreviewEnter(item, $any($event.currentTarget))"
        (mouseleave)="onItemPreviewLeave(item)"
        (focusin)="onItemPreviewEnter(item, $any($event.currentTarget))"
        (focusout)="onItemPreviewLeave(item)"
        tabindex="0">

        <div class="flex items-center justify-between gap-3">
          <div class="flex items-center gap-3 min-w-0">

            <div class="relative h-10 w-10 shrink-0 rounded-md bg-base-200 overflow-hidden">
              @if (item.image_thumb_url) {
                <img
                  [src]="item.image_thumb_url"
                  alt=""
                  class="absolute inset-0 h-full w-full object-contain"
                  useImageProxy>
              } @else {
                <div class="absolute inset-0 flex items-center justify-center text-base-content/40">
                  <fa-icon [icon]="faProductPlaceholder" size="sm"></fa-icon>
                </div>
              }
            </div>

            <div class="min-w-0">
              <div class="text-sm font-medium leading-snug truncate">
                {{ item.name }}
                @if (item.quantity) {
                  <span class="text-xs text-base-content/60"> – {{ item.quantity }}</span>
                }
              </div>
              @if (item.brand) {
                <div class="text-xs text-base-content/60 truncate">{{ item.brand }}</div>
              }
            </div>
          </div>

          <div class="shrink-0 flex flex-col items-end gap-1">
            <img
              [src]="getProviderLogoPath(item.provider) | async"
              [alt]="item.provider"
              class="h-4 object-contain"
            />
            @if (item.price !== undefined) {
              <span class="badge badge-primary badge-sm">{{ item.price }}</span>
            }
          </div>
        </div>

        @if (hoveredItemId === item.id) {
          <div
            class="catalog-result__preview"
            role="tooltip"
            aria-label="Product preview"
            [class.catalog-result__preview--left]="previewPlacement === 'left'"
            [style.top.px]="previewTopPx"
            [style.left.px]="previewLeftPx">
            <div class="flex gap-3">
              <div class="w-24 h-24 shrink-0 rounded-lg bg-base-200 overflow-hidden relative">
                @if (item.image_full_url) {
                  <img
                    [src]="item.image_full_url"
                    alt=""
                    class="absolute inset-0 h-full w-full object-contain"
                    useImageProxy>
                } @else if (item.image_thumb_url) {
                  <img
                    [src]="item.image_thumb_url"
                    alt=""
                    class="absolute inset-0 h-full w-full object-contain"
                    useImageProxy>
                } @else {
                  <div class="absolute inset-0 flex items-center justify-center text-base-content/40">
                    <fa-icon [icon]="faProductPlaceholder" size="2x"></fa-icon>
                  </div>
                }
              </div>

              <div class="min-w-0">
                <div class="font-semibold leading-snug wrap-break-word">{{ item.name }}</div>

                @if (item.brand) {
                  <div class="text-sm text-base-content/70 wrap-break-word">{{ item.brand }}</div>
                }

                <div class="mt-2 text-xs text-base-content/70 space-y-1">
                  @if (item.quantity) {
                    <div><span class="font-semibold">Quantity:</span> {{ item.quantity }}</div>
                  }
                  @if (item.price !== undefined) {
                    <div><span class="font-semibold">Price:</span> {{ item.price }}</div>
                  }
                  @if (item.provider) {
                    <div><span class="font-semibold">Provider:</span> {{ item.provider }}</div>
                  }
                  @if (item.codes?.length) {
                    <div class="truncate"><span class="font-semibold">Barcode:</span> {{ item.codes[0].value }}</div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </li>
    }
  </ul>

  <!-- Infinite scroll: sentinel is observed to auto-load the next page -->
  <div #scrollAnchor aria-hidden="true"></div>
  @if (loadingMore) {
    <div class="py-3 flex items-center justify-center gap-2 text-sm text-base-content/60">
      <span class="loading loading-spinner loading-sm"></span>
      Loading more…
    </div>
  }
  </div>
}
